export var media = function (node, _a) {
    var _b = _a === void 0 ? {} : _a, context = _b.context, parent = _b.parent;
    var wikiAttrs = [];
    // Parent width takes precedence over internal dimension attributes
    if (parent && parent.attrs.width) {
        // Parent width is defined in percents
        wikiAttrs.push("width=" + parent.attrs.width + "%");
    }
    else {
        if (node.attrs.width) {
            wikiAttrs.push("width=" + node.attrs.width);
        }
        if (node.attrs.height) {
            wikiAttrs.push("height=" + node.attrs.height);
        }
    }
    if (node.attrs.alt) {
        wikiAttrs.push("alt=\"" + node.attrs.alt + "\"");
    }
    var fileName;
    if (node.attrs.type === 'external') {
        fileName = node.attrs.url;
    }
    else {
        fileName =
            context &&
                context.conversion &&
                context.conversion.mediaConversion &&
                context.conversion.mediaConversion[node.attrs.id]
                ? context.conversion.mediaConversion[node.attrs.id]
                : node.attrs.id;
    }
    if (wikiAttrs.length) {
        return "!" + fileName + "|" + wikiAttrs.join(',') + "!";
    }
    // default to thumbnail if no width or height is set
    return "!" + fileName + "|thumbnail!";
};
//# sourceMappingURL=media.js.map